var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "EditCancel_svg__a",
  width: 14,
  height: 14,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h14v14H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#EditCancel_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.666 11.083a.56.56 0 0 1-.415-.168.56.56 0 0 1-.168-.415q0-.248.168-.416a.56.56 0 0 1 .415-.168h3.559a2.37 2.37 0 0 0 1.597-.583q.678-.584.678-1.458 0-.876-.678-1.459a2.37 2.37 0 0 0-1.597-.583H4.55l1.108 1.108q.16.161.16.409a.55.55 0 0 1-.16.408.55.55 0 0 1-.408.16.55.55 0 0 1-.409-.16l-2.1-2.1a.5.5 0 0 1-.123-.19.7.7 0 0 1-.037-.218q0-.116.037-.219a.5.5 0 0 1 .123-.19l2.1-2.1a.55.55 0 0 1 .409-.16q.247 0 .408.16.16.161.16.409a.55.55 0 0 1-.16.408L4.55 4.666h3.675q1.414 0 2.428.92 1.013.918 1.013 2.289t-1.013 2.29-2.428.918z"
}))));
export default SvgEditCancel;